module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "judementTempelet"
  }, [_c('div', {
    staticClass: "weui-cells__title"
  }, [_vm._v(_vm._s((_vm.index + 1) + '、' + _vm.cloums.judement.subjectName))]), _vm._v(" "), _c('checker', {
    attrs: {
      "max": 1,
      "default-item-class": "checkerItem",
      "selected-item-class": "checkerSelected"
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.cloums.judement.answer),
      callback: function($$v) {
        _vm.$set(_vm.cloums.judement, "answer", $$v)
      },
      expression: "cloums.judement.answer"
    }
  }, _vm._l((_vm.IsArry), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b87250","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/questionnaireTempelet/judementTempelet.vue
// module id = adTa
// module chunks = 5